import axios from "axios"
import qs from "qs"
import Router from '@/router'
import { Loading } from 'element-ui';
import { message } from './resetmessage';
import md5 from 'js-md5'
axios.defaults.timeout=100000   //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json'//'application/x-www-form-urlencoded;charset=UTF-8';        //配置请求头
axios.defaults.baseURL = process.env.API_HOST;   //配置接口地址
//console.log(process.env)

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    // let token = sessionStorage.getItem('token') || ""  //获取token 
    let token = localStorage.token ? JSON.parse(localStorage.token) : '';
    if (token!="") {
        config.headers = {
         'token': token,
         'Content-Type': 'application/json',
         'timestamp': new Date().getTime()
        }
    }    
    if(config.method  === 'post'){
        config.data = JSON.stringify(config.data)//序列化post 参数
        // config.data = config.data
    }
    return config;
},(error) =>{
    //console.log('错误的传参')
  
    return Promise.reject(error);
});
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    if(!res.data.success){
        let newToken = res.data.token    //成功后更新token 
        if(newToken){
            localStorage.setItem('token', newToken)
        }
    }
    return res;
}, (error) => {
      if(error == 'Error: Request failed with status code 50001'){    //如果token 过期 则跳转到登录页面
        Router.push('/');
      }
    return Promise.reject(error);
});
//返回一个Promise(发送post请求)
 function post(url, params) {
    let globalLoading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(255,255,255, 0.7)'
      })
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                globalLoading.close();
                if(response.data.code != 200 && response.data.code != '200'){
                    message.error(response.data.msg)
                }else{
                    resolve(response);
                }
            }, err => {
                globalLoading.close();
                message.error(err.data.msg);
                reject(err);
            })
            .catch((error) => {
                globalLoading.close();
                reject(error)
            })
    })
}
//返回一个Promise(发送get请求)
 function get(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
            .then(response => {
                if(response.data.code != 200 && response.data.code != 0){
                    message.error(response.data.msg)
                }else{
                    resolve(response);
                }
            }, err => {
                message.error(err.data.msg);
                reject(err);
            })
            .catch((error) => {
                message.error(error.data.msg);
                reject(error)
            })
    })
}
//返回一个Promise(发送put请求)
function put(url, param) {
    let globalLoading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(255,255,255, 0.7)'
      })
    return new Promise((resolve, reject) => {
        axios.put(url, param)
            .then(response => {
                globalLoading.close();
                if(response.data.code != 200){
                    message.error(response.data.msg)
                }else{
                    resolve(response);
                }
            }, err => {
                globalLoading.close();
                message.error(err.data.msg);
                reject(err);
            })
            .catch((error) => {
                globalLoading.close();
                message.error(error.data.msg);
                reject(error)
            })
    })
}
//返回一个Promise(发送delete请求)
function del(url, param) {
    let globalLoading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(255,255,255, 0.7)'
      })
    return new Promise((resolve, reject) => {
        axios.delete(url, param)
            .then(response => {
                globalLoading.close();
                if(response.data.code != 200){
                    message.error(response.data.msg)
                }else{
                    resolve(response);
                }
            }, err => {
                globalLoading.close();
                message.error(err.data.msg);
                reject(err);
            })
            .catch((error) => {
                globalLoading.close();
                message.error(error.data.msg);
                reject(error)
            })
    })
}

function blob(url,params){
    let globalLoading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(255,255,255, 0.7)'
    })
    let gs = '.xlsx'
    if(url == '/base/downloadQRCode'){
        gs = '.png'
    }
    axios({
        method: "post",
        url: url,
        data: params,
        responseType: "blob",
    })
    .then((res) => {
        message({
            type: 'success',
            message: '正在下载，请稍后~'
        });
        let url = window.URL.createObjectURL(new Blob([res.data],{type: 'application/vnd.ms-excel'}))
        if("msSaveOrOpenBlob" in navigator){
            //ie使用的下载方式
            window.navigator.msSaveOrOpenBlob(blob, Date.now()+gs);
        }else {
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', Date.now()+gs)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
        }
        globalLoading.close();
    })
    .catch((err) => {
        globalLoading.close();
        //console.log(err)
        if(err == 'Error: Request failed with status code 302'){
            message.error('请提交上月报表后再提交本报表');
        }
    });
}

function blobTmp(url,params){
    let globalLoading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(255,255,255, 0.7)'
    })
    let token = localStorage.token ? JSON.parse(localStorage.token) : '';
    axios({
        method: "post",
        url: url,
        data: params,
        responseType: "blob",
    })
    .then((res) => {
        message({
            type: 'success',
            message: '正在下载，请稍后~'
        });
        let url = window.URL.createObjectURL(new Blob([res.data],{type: 'application/vnd.ms-excel'}))
        if("msSaveOrOpenBlob" in navigator){
            //ie使用的下载方式
            window.navigator.msSaveOrOpenBlob(blob, Date.now()+'.docx');
        }else {
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', Date.now()+'.docx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
        }
        globalLoading.close();
    })
    .catch((err) => {
        globalLoading.close();
        //console.log(err)
        if(err == 'Error: Request failed with status code 302'){
            // message.error('请提交上月报表后再提交本报表');
        }
    });
}


export default {
    get,
    post,
    put,
    del,
    blob,
    blobTmp
}


// this.http.post('/MagicData/?c=analysis_mymx&m=new_mxfl',params).then((res)=>{
//     //console.log("123")
// }).catch(err=>{
//     //console.log(err)
// })




// WEBPACK FOOTER //
// ./src/utils/http.js